/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductIdentificationFilter
 */
export interface ProductIdentificationFilter {
    /**
     * 
     * @type {string}
     * @memberof ProductIdentificationFilter
     */
    batch?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductIdentificationFilter
     */
    materialCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductIdentificationFilter
     */
    serialNumber?: string;
}

/**
 * Check if a given object implements the ProductIdentificationFilter interface.
 */
export function instanceOfProductIdentificationFilter(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProductIdentificationFilterFromJSON(json: any): ProductIdentificationFilter {
    return ProductIdentificationFilterFromJSONTyped(json, false);
}

export function ProductIdentificationFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductIdentificationFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'batch': !exists(json, 'batch') ? undefined : json['batch'],
        'materialCode': !exists(json, 'materialCode') ? undefined : json['materialCode'],
        'serialNumber': !exists(json, 'serialNumber') ? undefined : json['serialNumber'],
    };
}

export function ProductIdentificationFilterToJSON(value?: ProductIdentificationFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'batch': value.batch,
        'materialCode': value.materialCode,
        'serialNumber': value.serialNumber,
    };
}

